import { Store } from '@medlinker/fundamental';
import MedDT, { UserDataEntity } from '@medlinker/data-tracker/browser';
import _ from 'lodash';
import sensors from 'sa-sdk-javascript';
import { SENSORS } from '../../shared/constants/hosts';
import env from '../../shared/utils/env';
import { userStorage } from '../../shared/storage';
// @ts-ignore
import pkgInfo from '../../../package.json';
import request from '../../shared/request';

export interface AppState {
  version: string;
}

const model = {
  name: 'app',
  state: { version: pkgInfo.version } as AppState,
  reducers: {},
  effects: {
    async init(payload: {}, store: Store) {
      const isProd = env.nodeEnv === 'production';

      sensors.init({
        // qa环境都是一个
        server_url: isProd ? SENSORS : '',
        /**
         * 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
         * 但自动上传会有一个问题，title可能是上个页面的标题
         */
        is_track_single_page: false,
        use_client_time: true,
        send_type: 'beacon',
        show_log: !isProd,
        heatmap: {
          //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
          clickmap: 'default',
          //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
          scroll_notice_map: 'not_collect',
        },
      });

      sensors.registerPage({
        platform_type: 'h5',
        platform_name: '医联健康公众号',
        user_type: '患者',
        is_login: () => !!store.getState().user?.info?.base?.userId,
      });

      let userInfo = store.getState().user.info;

      if (!userInfo) {
        try {
          userInfo = await request
            .get<any, any>(`/v1/user/profile`, {
              bodyType: 'json',
            })
            .setConfig({ skipLogin: true });
          store.dispatch.user.setUserInfo(userInfo);
        } catch (e) {}
      }

      if (userInfo?.base?.userId) {
        sensors.login(userInfo.base.userId.toString()); // userInfo.base.userId.toString()
      } else {
        sensors.logout();
      }

      userInfo &&
        sensors.setProfile({
          med_user_id: userInfo.base?.userId,
          med_user_name: userInfo.base?.userName,
          med_user_phone: userInfo.base?.phone,
        });

      MedDT.setUserId(userInfo ? userInfo.base.userId.toString() : '');

      MedDT.init({
        enable: process.env.NODE_ENV === 'production',
        env: env.appEnv,
      });

      MedDT.ready();

      if (typeof gio === 'function' && userInfo) {
        gio('setUserId', userInfo.base.userId.toString());
      }

      if (typeof Sentry !== 'undefined' && userInfo) {
        Sentry.setUser({ id: userInfo.base.userId.toString() });
        Sentry.setExtra('userInfo', {
          base: _.omit(userInfo.base, ['phone', 'mail']),
          patient: _.pick(userInfo.patient, ['id', 'name']),
          patientBase: _.pick(userInfo.patientBase || {}, [
            'patientId',
            'name',
          ]),
          third: userInfo.third,
        });
      }

      if (typeof monitor !== 'undefined' && userInfo) {
        monitor.setConfig({
          p: userInfo.base.phone,
          uid: userInfo.base.userId.toString(),
        });
      }
    },

    async collect(config: UserDataEntity) {
      MedDT.collect(config);
    },

    async collectPU(config: { title: string }) {
      MedDT.collect({
        b: 'patient',
        ei: 0,
        ep: '',
        lt: 1,
        /**
         * 手动传人标题，document.title设置是异步的
         */
        // @ts-ignore
        pt: config.title,
      });
      // 路由变化时执行 sensors.quick("autoTrackSinglePage");
      sensors.quick('autoTrackSinglePage', {
        $title: config.title,
      });
    },

    async clearUserContext(config: {}, store: Store) {
      store.dispatch.resetState();
      userStorage.removeAll();
    },
  },
};

export default model;
